var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Security_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security_Active",
    "data-name": "Security Active",
    clipPath: "url(#clip-Security_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(0.25 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M10.9,27.251h0A29.531,29.531,0,0,1,5.451,23.5,19.186,19.186,0,0,1,1.7,19.2,10.6,10.6,0,0,1,0,13.626V4.088L10.9,0l10.9,4.088v9.538A10.6,10.6,0,0,1,20.1,19.2a19.193,19.193,0,0,1-3.748,4.3A29.527,29.527,0,0,1,10.9,27.251Zm.306-20.12a6.112,6.112,0,1,0,6.113,6.112A6.12,6.12,0,0,0,11.209,7.131Z",
    transform: "translate(5 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield",
    "data-name": "Icon feather-shield",
    d: "M17.4,32.25a.762.762,0,0,1-.341-.081,30.8,30.8,0,0,1-5.856-4.023,20.805,20.805,0,0,1-4.063-4.668A11.824,11.824,0,0,1,5.25,17.25V7.284a.763.763,0,0,1,.495-.714L17.135,2.3a.763.763,0,0,1,.536,0L29.06,6.57a.763.763,0,0,1,.495.714V17.25a11.824,11.824,0,0,1-1.893,6.228A20.805,20.805,0,0,1,23.6,28.146a30.8,30.8,0,0,1-5.856,4.023A.762.762,0,0,1,17.4,32.25ZM6.775,7.812V17.25c0,4.116,2.942,7.561,5.409,9.726A30.434,30.434,0,0,0,17.4,30.624a30.434,30.434,0,0,0,5.218-3.648c2.468-2.165,5.409-5.61,5.409-9.726V7.812L17.4,3.827Z",
    transform: "translate(-1.5 -0.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M16.543,21.672h0a.66.66,0,0,1-.509-.218l-1.4-1.417A.732.732,0,0,1,15.671,19l.89.89,2.362-2.326A.732.732,0,0,1,19.96,18.6l-2.871,2.835a.8.8,0,0,1-.509.218Z",
    transform: "translate(-1.217 -3.11)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityActive);
export default __webpack_public_path__ + "static/media/Security_Active.5260eeb20c09af4b3d24679216b132e6.svg";
export { ForwardRef as ReactComponent };